import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

export function IntegrationSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Integrations</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-muted-foreground">
            No integrations are available yet. Stay tuned for upcoming features!
          </p>
          
          <div className="bg-muted/50 p-4 rounded-lg">
            <h3 className="font-medium mb-2">Coming Soon</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Procore - Sync projects and data seamlessly</li>
              <li>• Microsoft Project - Import and export project schedules</li>
              <li>• Power BI - Advanced data visualization and reporting</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}